import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { AddOnCardLayoutUI } from '../../../components/available-add-ons-list/AddOnCardLayoutUI';
import { createAddOnCardTrackingData } from '../../utils/trackingData';
import { AddOnAlert } from './AddOnAlert';
import { AddOnCTA } from './AddOnCTA';
import { AddOnPricing } from './AddOnPricing';
import { jsx as _jsx } from "react/jsx-runtime";
export function AddOnCard({
  productApiName,
  titleText,
  descriptionText,
  productDetails,
  purchaseMotion,
  purchaseOption,
  ownedQuantity,
  includedQuantity,
  isHubSpotCredits,
  currencyCode
}) {
  var _productDetails$packa, _productDetails$packa2;
  const price = purchaseOption && purchaseOption.monthlyPrice ? Number(purchaseOption.monthlyPrice) : null;
  const trackingData = createAddOnCardTrackingData(productApiName);

  // the number of units the product you get when you purchase the add-on
  const packagedQuantity = isHubSpotCredits ? (_productDetails$packa = productDetails === null || productDetails === void 0 || (_productDetails$packa2 = productDetails.packagedQuantitiesMap) === null || _productDetails$packa2 === void 0 ? void 0 : _productDetails$packa2['HUBSPOT_CREDITS']) !== null && _productDetails$packa !== void 0 ? _productDetails$packa : 1 : 1;
  const description = isHubSpotCredits ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "touchless-buying-components.hubSpotCredits.description"
  }) : descriptionText;
  return /*#__PURE__*/_jsx(AddOnCardLayoutUI, {
    "data-test-id": `add-on-card-${productApiName}`,
    "data-selenium-id": `add-on-card-${productApiName}`,
    title: titleText,
    description: description,
    pricing: price ? /*#__PURE__*/_jsx(AddOnPricing, {
      productApiName: productApiName,
      price: price,
      isHubSpotCredits: isHubSpotCredits,
      packagedQuantities: packagedQuantity,
      currencyCode: currencyCode
    }) : null,
    alert: /*#__PURE__*/_jsx(AddOnAlert, {
      productApiName: productApiName,
      ownedQuantity: ownedQuantity,
      includedQuantity: includedQuantity,
      isHubSpotCredits: isHubSpotCredits
    }),
    cta: /*#__PURE__*/_jsx(AddOnCTA, {
      productApiName: productApiName,
      trackingData: trackingData,
      productDetails: productDetails,
      ownedQuantity: ownedQuantity,
      purchaseMotion: purchaseMotion,
      purchaseOption: purchaseOption,
      isHubSpotCredits: isHubSpotCredits
    })
  });
}